import React from 'react';
import styled from 'astroturf/react';

const ParentDiv = styled.div`
  text-align: center;
  margin: auto;
`;
const ChildDiv = styled.div`
  display: inline-block;
  margin: auto;
`;

export const CenteredDiv: React.FC<React.PropsWithChildren> = (props) => {
  return (
    <ParentDiv>
      <ChildDiv>{props.children}</ChildDiv>
    </ParentDiv>
  );
};
